import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { BaseFormModel } from '../../../../hooks/useFormState.types';
import colors from '../../../../themes/main-colors';
import { PersonalIdentificationType } from '../../../../__generated__/pge-types';
import AlternateIDVerification from './AlternateIDVerification';
import SSNVerification from './SSNVerification';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
  }),
);

export enum IDENTITY_VERIFICATION_PANEL_TYPES {
  SSN = 'ssn',
  ALTERNATIVE_ID = 'alternative',
}

interface Props {
  form: BaseFormModel;
}

const IdentityVerification = ({ form }: Props) => {
  const classes = useStyles();
  const { idType } = form.values;

  const [activePanel, setActivePanel] = React.useState<
    IDENTITY_VERIFICATION_PANEL_TYPES
  >(
    idType && idType !== PersonalIdentificationType.Ssn
      ? IDENTITY_VERIFICATION_PANEL_TYPES.ALTERNATIVE_ID
      : IDENTITY_VERIFICATION_PANEL_TYPES.SSN,
  );

  return (
    <Grid
      item
      container
      spacing={2}
      className={classes.root}
      data-testid="identity-verification"
    >
      <SSNVerification
        form={form}
        activePanel={activePanel}
        setActivePanel={setActivePanel}
      />
      <AlternateIDVerification
        form={form}
        activePanel={activePanel}
        setActivePanel={setActivePanel}
      />
    </Grid>
  );
};

export default IdentityVerification;
